// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip","show":"show","text":"text"};